import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const PaymentConfirmation = lazy(() => import("@/pages/PaymentConfirmation"));

export const Route = createFileRoute("/payment/confirm")({
  component: PaymentConfirmation,
});
